import {observer} from 'mobx-react';
import React from 'react';
import TextareaAutosize from 'react-textarea-autosize';
import {SelectQuestionEditStore} from '../SelectQuestionEditStore';

@observer
export class SelectQuestionTextArea extends React.Component<{ store: SelectQuestionEditStore }> {
  render() {
    const store = this.props.store;

    return (
      <TextareaAutosize className="form-control"
                        value={store.serialized.value}
                        onChange={store.serialized.onChangeHandler}>
      </TextareaAutosize>
    );
  }
}
